import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import SUHomepage from '../common/SUHomepage';
import PUHomepage from '../common/PUHomepage';
import { ROLES } from '../utils/constants';
import { setUser, setUser as setUserRx } from '../../redux/actions';
import Guest from './guest';

const Homepage = ({
    userInformation
}) => {
    const dispatch = useDispatch();

    const isLoggedIn = localStorage.getItem('loggedin_user');

    useEffect(() => {
        let isMounted = true;
        if (isLoggedIn) {
            dispatch(setUser());
        }

        return () => {
            return isMounted = false;
        };
    }, []);

    if (isLoggedIn) {
        return (
            <>
                {
                    userInformation && userInformation.role === ROLES.SU && <SUHomepage />
                }
                {
                    userInformation && [ROLES.PU, ROLES.ADMIN].includes(parseInt(userInformation.role)) && <PUHomepage />
                }
            </>
        );
    }

    return <Guest />;
};

const mapStateToProps = state => ({
    userInformation: state.user.user
});

export default connect(mapStateToProps)(Homepage);
